export default class TriangleVisitor {
  visit(triEdges) {}
}
